import { createSelector, createSlice } from "@reduxjs/toolkit";
import { ensureArray } from "../common/utils/arrayUtilities";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from "../common/reducers/utilities";

export const crewStatusSlice = createSlice({
    name: 'crewStatus',
    initialState: {
        data: []
    },
    reducers: {
        set: (state, action) => {
            state.data = action.payload
        },
        addOrUpdate: (state, action) => {
            for (const status of ensureArray(action.payload)) {
                const idx = state.data.findIndex(s => s.name === status.name);
                if (idx > -1) {
                    state.data.splice(idx, 1, status);
                } else {
                    state.data.push(status);
                }
            }
        },
        remove: (state, action) => {
            for (const status of ensureArray(action.payload)) {
                const idx = state.data.findIndex(s => s.name === status.name);
                if (idx > -1) {
                    state.data.splice(idx, 1)
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => crewStatusSlice.getInitialState());
    }
});

// #region network operations
const fetchCrewStatuses = network => network.get('/api/v1/crewstatuses', crewStatusSlice.actions.set);
export const createCrewStatus = (network, status) => network.post('/api/v1/crewstatus', status, crewStatusSlice.actions.addOrUpdate);
export const updateCrewStatus = (network, status) => network.put('/api/v1/crewstatus', status, crewStatusSlice.actions.addOrUpdate);
export const removeCrewStatus = (network, status) => network.delete('/api/v1/crewstatus/' + encodeURIComponent(status.name), crewStatusSlice.actions.remove);
// #endregion

// #region selectors
const selectCrewStatuses = state => state.crewStatus.data
const selectCrewStatusByName = createSelector([selectCrewStatuses, (state, name) => name], (statuses, name) => statuses.find(s => s.name === name));
const selectCrewStatus = name => state => selectCrewStatusByName(state, name);
// #endregion

// #region listeners
const listen = {
    crewStatusCreated: (status, { dispatch }) => dispatch(crewStatusSlice.actions.addOrUpdate(status)),
    crewStatusUpdated: (status, { dispatch }) => dispatch(crewStatusSlice.actions.addOrUpdate(status)),
    crewStatusRemoved: (status, { dispatch }) => dispatch(crewStatusSlice.actions.remove(status))
}
// #endregion

// #region permission checks
export const canInsertCrewStatus = (credentials) => credentials.access.hasFull('administrator');
export const canUpdateCrewStatus = canInsertCrewStatus;
export const canRemoveCrewStatus = canInsertCrewStatus;
// #endregion

export const [useCrewStatuses] = dataHookFactory(selectCrewStatuses, { run: fetchCrewStatuses, listen, immortal: true });
export const [useCrewStatus] = dataHookFactory(selectCrewStatus, name => ({ run: fetchCrewStatuses, listen, immortal: true }));

const reducerDetails = { name: crewStatusSlice.name, reducer: crewStatusSlice.reducer };
export default reducerDetails;